import * as React from 'react';
import running from "../../assets/icon/running.gif";
import sunbathing from "../../assets/icon/sunbathing.gif";
import walk from "../../assets/icon/walk.gif";
import careStore from "../../store/careStore";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useEffect} from "react";


const CareActivity = () => {
  const storeData: any = careStore();
  
  useEffect(() => {
    if(storeData.careInfo.work_strength === ''){
      storeData.setCareInfo('work_strength', '보통');
    }
    
    return () => {
      storeData.setCareInfo('goal', 0);
      storeData.setCareInfo('food', 0);
    }
  }, []);
    
  // 선택 항목 클릭 이벤트
  const handleCheckedBoxes = (e :any) => {
    const targetName = e.target.name;
    if(e.target.checked){
      storeData.setCareInfo('work_strength', targetName);
    }else{
      storeData.setCareInfo('work_strength', '');
    }
  };
  
  
  
  return (
    
    <Stack  sx={{ width: '100%', background:'#F1F2F4', minWidth:320}} spacing={2}>

      <Grid sx={{bgcolor:'#fff', p:0, pt:2,pb:3, width:'100%',minHeight:515   }}>
        <Box sx={{ boxSizing: 'border-box',}}>
          <Typography  component="div" sx={{fontSize:18, pb:1,color:'#555', m:4, mb:0, textAlign:'center'}}>
            평소 활동량을 선택해 주세요.
          </Typography>
  
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row', p:1,
              margin:' 0 auto',
              boxSizing: 'border-box',
              justifyContent:'center',
              '& .MuiFormControlLabel-root': {}
            }}
          >
            <FormGroup sx={{p:0, justifyContent:"center"}} aria-label="position" row >
              <Stack flexDirection={'row'} >
                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130,  borderRadius:'50%',textAlign:'center'}}>
                  <Avatar alt="" src={sunbathing} sx={{ m:'10px auto'}} variant="square" />
                  <FormControlLabel sx={{m:0}} control={
                    <Checkbox onClick={handleCheckedBoxes} name="적음" checked={storeData.careInfo.work_strength === '적음'}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="거의 앉아 있음"  
                      labelPlacement="top" 
                    />
                </Box>
  
                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <Avatar alt="" src={walk} sx={{m:'10px auto'}} />
                  <FormControlLabel sx={{m:0}} control={
                    <Checkbox onClick={handleCheckedBoxes} name="보통" checked={storeData.careInfo.work_strength === '보통' || storeData.careInfo.work_strength === ''}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="운동량이 있음"  
                      labelPlacement="top" 
                    />
                </Box>
              </Stack>
  
              <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                <Avatar alt="" src={running} sx={{ m:'10px auto'}} />
                <FormControlLabel sx={{m:0}} control={
                  <Checkbox onClick={handleCheckedBoxes} name="많음" checked={storeData.careInfo.work_strength === '많음'}
                    icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                    
                    sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                      color: '#3ecbca',
                    },  }} />} 
                    label="운동량이 많음"  
                    labelPlacement="top" 
                  />
              </Box>
            </FormGroup>
          </Box>
          
        </Box>
      </Grid>

  </Stack >
  );
}

export default CareActivity;